import React, { useRef, useEffect } from "react";
import Preloader from "../Preloader/Preloader";
import {
  getbookSameDayList,
  ResetbBookSameDataState,
} from "../../store/Slice/bookSameDaySlice";
import { useDispatch, useSelector } from "react-redux";

import {
  getCleaningSameDayList,
  ResetCleaningSameDayDataState,
} from "../../store/Slice/cleaningSameDaySlice";
import { getResidenceTypeList } from "../../store/Slice/residenceTypeSlice";
import { ResetBookNowDetailState } from "../../store/Slice/bookNowDetailSlice";
import { getExtrasDetailList } from "../../store/Slice/extrasDetailSlice";
import { getServicesDetailList } from "../../store/Slice/servicesDetailSlice";
import { getCityListing } from "../../store/Slice/CityListingSlice";

import PaymentForm from "../Checkout/PaymentForm";
import { useLocation } from "react-router-dom";
import { getCustomerProfileById } from "../../store/Slice/customerProfileSlice";

const loadScript = (url, callback) => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;

  script.onload = callback;

  document.head.appendChild(script);
};

const useBookNowClearSessionOnNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    const clearSessionData = () => {
      const sessionKeys = [
        "bookSameDayBookingId",
        "bookCheckAvailabilityClick",
        "bookSubmitClick",
        "bookPayButtonClick",
        "bookedNowButtonClick",
        "bookScheduledTime",
        "bookPrice",
        "bookEstimatedTime",
        "bookPricePerHour",
        "bookTax",
        "bookFinalPrice",
        "bookCustomerName",
        "bookCity",
        "bookSelectedServiceName",

        "bookSelectedExtras",
        "bookCustomerEmail",
        "bookBathroom",
        "bookFromTime",
        "bookCustomerPhone",
        "bookDate",
        "bookResidence",
        "bookServiceId",
        "bookUntillTime",
        "bookAddress",
        "bookBedroom",
        "bookUnit",
      ];

      sessionKeys.forEach((key) => sessionStorage.removeItem(key));
    };

    clearSessionData();
  }, [location.pathname]);
};

const BookFormOne = ({ labelDetailData }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const autocompleteRef = useRef(null);
  const autocomplete = useRef(null);

  const [userfullName, setUserFullName] = React.useState("");
  const [userPhone, setUserPhone] = React.useState("");
  const [userEmail, setUserEmail] = React.useState("");
  const [isBookLoading, setIsBookLoading] = React.useState(false);
  const [bookLoading, setBookLoading] = React.useState(false);
  const [bookFirstFormShow, setBookFirstFormShow] = React.useState(false);
  const [bookSecondFormShow, setBookSecondFormShow] = React.useState(false);

  const [bookedNowDetailLoading, setBookedNowDetailLoading] =
    React.useState(false);

  const [userAddress, setUserAddress] = React.useState("");
  const [userResidence, setUserResidence] = React.useState("");
  const [userBedrooms, setUserBedrooms] = React.useState("");
  const [userBathrooms, setUserBathrooms] = React.useState("");
  const [userCity, setUserCity] = React.useState("");
  const [userSelectedExtras, setUserSelectedExtras] = React.useState([]);
  const [userDate, setUserDate] = React.useState("");
  const [userFromTime, setUserFromTime] = React.useState("");
  const [userAvailableTimes, setUserAvailableTimes] = React.useState([]);
  const [userUntillTime, setUserUntillTime] = React.useState("");
  const [userServiceId, setUserServiceId] = React.useState("");
  const [userUnit, setUserUnit] = React.useState("");

  const [userFullNameError, setUserFullNameError] = React.useState("");
  const [userPhoneError, setUserPhoneError] = React.useState("");
  const [userEmailError, setUserEmailError] = React.useState("");

  const [userAddressError, setUserAddressError] = React.useState("");
  const [userResidencError, setUserResidenceError] = React.useState("");
  const [userBedroomsError, setUserBedroomsError] = React.useState("");
  const [userBathroomsError, setUserBathroomsError] = React.useState("");
  const [userCityError, setUserCityError] = React.useState("");

  const [userFromTimeError, setUserFromTimeError] = React.useState("");
  const [userUntillTimeError, setUserUntillTimeError] = React.useState("");
  const [userDateError, setUserDateError] = React.useState("");
  const [userServiceIdError, setUserServiceIdError] = React.useState("");
  const [userUnitError, setUserUnitError] = React.useState("");

  const [formOneMessageError, setFormOneMessageError] = React.useState("");
  const [formTwoMessageError, setFormTwoMessageError] = React.useState("");

  const [formErrorMessage, setFormErrorMessage] = React.useState(null);

  const dateInputRef = useRef(null);

  const isCustomerLoggedIn = sessionStorage.getItem("Customer-vUniqueCode");
  const bookSubmitClick = sessionStorage.getItem("bookSubmitClick");

  const bookCheckAvailabilityClick = sessionStorage.getItem(
    "bookCheckAvailabilityClick"
  );

  const bookedNowButtonClick = sessionStorage.getItem("bookedNowButtonClick");

  const bookCustomerName = sessionStorage.getItem("bookCustomerName");

  const bookCleningPrice = sessionStorage.getItem("bookPrice");
  const bookEstimatedTime = sessionStorage.getItem("bookEstimatedTime");
  const bookPricePerHour = sessionStorage.getItem("bookPricePerHour");

  const bookUserAddressValue = sessionStorage.getItem("bookAddress");
  const bookSelectedServiceName = sessionStorage.getItem(
    "bookSelectedServiceName"
  );
  const bookSelectedExtras = sessionStorage.getItem("bookSelectedExtras");

  const bookExtrasValue = bookSelectedExtras
    ? JSON.parse(bookSelectedExtras)
    : [];

  const bookExtrasfinalValue = bookExtrasValue.join(", ");

  const bookFromTimeValue = sessionStorage.getItem("bookFromTime");

  const bookFromTimeNewValue = bookFromTimeValue
    ? bookFromTimeValue.replace(/^0/, "").replace(":00", "").toUpperCase()
    : "";

  const bookUntillTimeValue = sessionStorage.getItem("bookUntillTime");

  const bookUntillTimeNewValue = bookUntillTimeValue
    ? bookUntillTimeValue.replace(/^0/, "").replace(":00", "").toUpperCase()
    : "";

  const bookDateValue = sessionStorage.getItem("bookDate");

  // const bookUserSeleteddate = new Date(bookDateValue);
  // const finalBookDatebookValue = bookUserSeleteddate.toLocaleDateString(
  //   "en-US",
  //   {
  //     month: "long",
  //     day: "numeric",
  //   }
  // );

  let finalBookDatebookValue = "";
  if (bookDateValue) {
    const [year, month, day] = bookDateValue.split("-");

    // Always local (no UTC shift)
    const userSelectedDate = new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    );

    finalBookDatebookValue = `${userSelectedDate.toLocaleString("en-CA", {
      month: "long",
    })} ${day}`;
  }

  const { bookSameDayData } = useSelector((state) => state.bookSameDayList);

  const { cleaningSameDayData } = useSelector(
    (state) => state.cleaningSameDayList
  );

  const { servicesDetailData } = useSelector(
    (state) => state.servicesDetailList
  );

  const { residenceTypeData } = useSelector((state) => state.residenceTypeList);

  const { cityListingData } = useSelector((state) => state.cityListing);

  const { bookNowDetailData } = useSelector((state) => state.bookNowDetailList);

  const { extrasDetailData } = useSelector((state) => state.extrasDetailList);

  const { customerProfileDetailData } = useSelector(
    (state) => state.customerProfileDetail
  );

  React.useEffect(() => {
    if (isCustomerLoggedIn) {
      dispatch(
        getCustomerProfileById({
          vUniqueCode: isCustomerLoggedIn,
        })
      );
    }
  }, [isCustomerLoggedIn, dispatch]);

  React.useEffect(() => {
    if (
      customerProfileDetailData &&
      customerProfileDetailData.code === 200 &&
      customerProfileDetailData?.data
    ) {
      setUserFullName(
        customerProfileDetailData?.data?.vFirstName +
          " " +
          customerProfileDetailData?.data?.vLastName || ""
      );
      setUserEmail(customerProfileDetailData?.data?.vEmail || "");
      setUserPhone(customerProfileDetailData?.data?.vMobile || "");
    }
  }, [customerProfileDetailData]);

  React.useEffect(() => {
    dispatch(getServicesDetailList());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getResidenceTypeList());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getExtrasDetailList());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getCityListing());
  }, [dispatch]);

  React.useEffect(() => {
    setUserFullName(sessionStorage.getItem("bookCustomerName") || "");
    setUserPhone(sessionStorage.getItem("bookCustomerPhone") || "");
    setUserEmail(sessionStorage.getItem("bookCustomerEmail") || "");
  }, []);

  const handleFullNameChange = (event) => {
    const fullNameValue = event.target.value;
    setUserFullName(fullNameValue);
    sessionStorage.setItem("bookCustomerName", fullNameValue);
    event.target.value.trim() !== "" && setUserFullNameError("");

    if (fullNameValue.trim() === "" && fullNameValue.length === 0) {
      setUserFullNameError("Full Name is Required.");
    } else {
      setUserFullNameError("");
    }
  };
  const handlePhoneChange = (event) => {
    const phoneValue = event.target.value.trim();
    if (!/^\d*$/.test(phoneValue)) {
      return;
    }
    setUserPhone(phoneValue);
    sessionStorage.setItem("bookCustomerPhone", phoneValue);
    event.target.value.trim() !== "" && setUserPhoneError("");
    if (phoneValue.trim() === "" && phoneValue.length === 0) {
      setUserPhoneError("Phone Number is Required.");
    } else if (+phoneValue.length === 10) {
      setUserPhoneError("");
    } else {
      setUserPhoneError("Invalid Phone Number.");
    }
    setFormOneMessageError("");
  };

  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    setUserEmail(emailValue);
    sessionStorage.setItem("bookCustomerEmail", emailValue);
    event.target.value.trim() !== "" && setUserEmailError("");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailValue === "" && emailValue.length === 0) {
      setUserEmailError("Email is Required.");
    } else if (!emailRegex.test(emailValue)) {
      setUserEmailError("Invalid Email Format.");
    } else {
      setUserEmailError("");
    }

    setFormOneMessageError("");
  };

  const ValidateSameDayForm = React.useCallback(() => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10,12}$/;
    setUserFullNameError("");
    setUserPhoneError("");
    setUserEmailError("");

    if (userfullName.trim() === "" && userfullName.length === 0) {
      setUserFullNameError("Full Name is Required.");
      isValid = false;
    }

    if (userPhone.trim() === "") {
      setUserPhoneError("Phone Number is Required.");
      isValid = false;
    } else if (+userPhone.length === 10) {
      setUserPhoneError("");
    } else if (!phoneRegex.test(userPhone)) {
      setUserPhoneError("Invalid Phone Number.");
      isValid = false;
    }

    if (userEmail === "" && userEmail.length === 0) {
      setUserEmailError("Email is Required.");
      isValid = false;
    } else if (!emailRegex.test(userEmail)) {
      setUserEmailError("Invalid Email Format.");
      isValid = false;
    }

    return isValid;
  }, [userfullName, userPhone, userEmail]);

  const handleSameDayBookFormNew = React.useCallback(
    (e) => {
      e.preventDefault();

      const isValidForm = ValidateSameDayForm();
      if (isValidForm) {
        setBookLoading(true);
        dispatch(
          getbookSameDayList({
            vFullName: userfullName,
            vEmail: userEmail,
            vMobile: userPhone,
          })
        );
      }
    },
    [ValidateSameDayForm, userfullName, userEmail, userPhone, dispatch]
  );

  React.useEffect(() => {
    if (bookSameDayData && bookSameDayData.code === 200) {
      setBookLoading(true);
      setTimeout(() => {
        setBookLoading(false);
        setFormOneMessageError("");

        setBookFirstFormShow(false);
        sessionStorage.setItem("bookSubmitClick", true);
      }, 2000);
      sessionStorage.setItem(
        "bookSameDayBookingId",
        bookSameDayData && bookSameDayData.id
      );
      sessionStorage.setItem("bookCustomerName", userfullName);
      dispatch(ResetbBookSameDataState());
    } else if (bookSameDayData && bookSameDayData.code === 400) {
      setBookFirstFormShow(true);
      setBookLoading(false);
      sessionStorage.setItem("bookSubmitClick", false);
      setFormOneMessageError(bookSameDayData.message);
      dispatch(ResetbBookSameDataState());

      // setTimeout(() => {
      //   setFormOneMessageError("");
      // }, 2000);
    } else if (bookSameDayData && bookSameDayData.code === 404) {
      sessionStorage.setItem("bookSubmitClick", false);
      setBookLoading(false);

      setFormOneMessageError(bookSameDayData.message);
      dispatch(ResetbBookSameDataState());

      // setTimeout(() => {
      //   setFormMessageError("");
      // }, 2000);
    }
  }, [dispatch, bookSameDayData, userfullName]);

  const updateStateFromSessionStorage = () => {
    setUserResidence(sessionStorage.getItem("bookResidence") || "");
    setUserServiceId(sessionStorage.getItem("bookServiceId") || "");
    setUserBedrooms(sessionStorage.getItem("bookBedroom") || "");
    setUserBathrooms(sessionStorage.getItem("bookBathroom") || "");
    setUserCity(sessionStorage.getItem("bookCity") || "");
    setUserAddress(sessionStorage.getItem("bookAddress") || "");
    setUserDate(sessionStorage.getItem("bookDate") || "");
    setUserUnit(sessionStorage.getItem("bookUnit") || "");
    setUserFromTime(sessionStorage.getItem("bookFromTime") || "");
    setUserUntillTime(sessionStorage.getItem("bookUntillTime") || "");
    const storedExtras =
      JSON.parse(sessionStorage.getItem("bookSelectedExtras")) || [];
    setUserSelectedExtras(storedExtras);
  };

  React.useEffect(() => {
    updateStateFromSessionStorage();
  }, []);

  // const handleDateChange = (event) => {
  //   const dateValue = event.target.value;
  //   setUserDate(dateValue);
  //   sessionStorage.setItem("bookDate", dateValue);
  //   event.target.value.trim() !== "" && setUserDateError("");

  //   if (dateValue.trim() === "" && dateValue.length === 0) {
  //     setUserDateError("Please select the date.");
  //   } else {
  //     setUserDateError("");
  //   }
  // };
  const handleDateChange = (event) => {
    const dateValue = event.target.value;
    setUserDate(dateValue);
    sessionStorage.setItem("bookDate", dateValue);

    if (!dateValue) {
      setUserDateError("Please select the date.");
    } else {
      setUserDateError("");
    }
  };

  const handleDateDivClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker(); // Open the date picker
    }
  };

  const handleResidence = (event) => {
    const residenceValue = event.target.value;
    setUserResidence(residenceValue);
    sessionStorage.setItem("bookResidence", residenceValue);

    if (residenceValue === "") {
      setUserResidenceError("Please select the type of residence.");
    } else {
      setUserResidenceError("");
    }
  };

  const handleBedrooms = (event) => {
    const bedroomsValue = +event.target.value;

    setUserBedrooms(bedroomsValue);
    sessionStorage.setItem("bookBedroom", bedroomsValue);
    if (bedroomsValue === "") {
      setUserBedroomsError("Please select the total number of bedrooms.");
    } else {
      setUserBedroomsError("");
    }
  };
  const handleBathrooms = (event) => {
    const bathroomsValue = +event.target.value;
    setUserBathrooms(bathroomsValue);
    sessionStorage.setItem("bookBathroom", bathroomsValue);
    if (bathroomsValue === "") {
      setUserBathroomsError("Please select the total number of bathrooms.");
    } else {
      setUserBathroomsError("");
    }
  };

  const handleCity = (event) => {
    const cityValue = event.target.value;
    setUserCity(cityValue);
    sessionStorage.setItem("bookCity", cityValue);
    if (cityValue === "") {
      setUserCityError("Please select the city.");
    } else {
      setUserCityError("");
    }
  };

  const handleServiceChange = (event) => {
    const serviceIdValue = +event.target.value;
    setUserServiceId(serviceIdValue);
    sessionStorage.setItem("bookServiceId", serviceIdValue);

    const selectedBookService = servicesDetailData?.data?.find(
      (service) => service.iServiceId === serviceIdValue
    );

    if (selectedBookService) {
      sessionStorage.setItem(
        "bookSelectedServiceName",
        selectedBookService.vServiceName
      );
    }

    if (serviceIdValue === "") {
      setUserServiceIdError("Please select the service.");
    } else {
      setUserServiceIdError("");
    }
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    let updatedExtras;

    if (checked) {
      updatedExtras = [...userSelectedExtras, value];
    } else {
      updatedExtras = userSelectedExtras.filter((extra) => extra !== value);
    }

    setUserSelectedExtras(updatedExtras);
    sessionStorage.setItem("bookSelectedExtras", JSON.stringify(updatedExtras));
  };

  const handleFromTime = (event) => {
    const fromTimeValue = event.target.value;
    setUserFromTime(fromTimeValue);
    sessionStorage.setItem("bookFromTime", fromTimeValue);
    if (fromTimeValue === "") {
      setUserFromTimeError("Please Select a From time.");
    } else {
      setUserFromTimeError("");
    }
  };

  const handleUnitChange = (event) => {
    const unitValue = event.target.value;
    setUserUnit(unitValue);
    sessionStorage.setItem("bookUnit", unitValue);
    event.target.value.trim() !== "" && setUserUnitError("");
  };

  const generateAvailableTimes = (selectedDate) => {
    const now = new Date();
    const selected = new Date(selectedDate);

    let currentHour = now.getHours();
    let currentMinutes = now.getMinutes();

    const times = [
      "12:00AM",
      "1:00AM",
      "2:00AM",
      "3:00AM",
      "4:00AM",
      "5:00AM",
      "6:00AM",
      "7:00AM",
      "8:00AM",
      "9:00AM",
      "10:00AM",
      "11:00AM",
      "12:00PM",
      "01:00PM",
      "02:00PM",
      "03:00PM",
      "04:00PM",
      "05:00PM",
      "06:00PM",
      "07:00PM",
      "08:00PM",
      "09:00PM",
      "10:00PM",
      "11:00PM",
    ];

    let filteredTimes = times;

    // If the selected date is today, filter times after the current time
    if (
      selected.getFullYear() === now.getFullYear() &&
      selected.getMonth() === now.getMonth() &&
      selected.getDate() === now.getDate()
    ) {
      filteredTimes = times.filter((time) => {
        let [hour, minutes] = time.split(/[:\s]/);
        let modifier = time.includes("PM") ? "PM" : "AM";
        let parsedHour = parseInt(hour, 10);

        if (modifier === "PM" && parsedHour !== 12) parsedHour += 12;
        if (modifier === "AM" && parsedHour === 12) parsedHour = 0;

        return (
          parsedHour > currentHour ||
          (parsedHour === currentHour && parseInt(minutes) > currentMinutes)
        );
      });
    }

    setUserAvailableTimes(filteredTimes);
  };

  useEffect(() => {
    if (userDate) {
      generateAvailableTimes(userDate);
    }
  }, [userDate]);

  const handleUntillTime = (event) => {
    const untillTimeValue = event.target.value;
    setUserUntillTime(untillTimeValue);
    sessionStorage.setItem("bookUntillTime", untillTimeValue);

    const fromTime24 = convertTo24Hour(userFromTime);
    const untillTime24 = convertTo24Hour(untillTimeValue);

    if (!untillTimeValue) {
      setUserUntillTimeError("Please select an Until time.");
    } else if (untillTime24 <= fromTime24) {
      setUserUntillTimeError("Until time must be greater than From time.");
    } else {
      setUserUntillTimeError("");
    }
  };

  const ValidateCheckAvailabilityForm = React.useCallback(() => {
    let isValid = true;

    const fromTime24 = convertTo24Hour(userFromTime);
    const untillTime24 = convertTo24Hour(userUntillTime);

    setUserResidenceError("");
    setUserCityError("");
    setUserBedroomsError("");
    setUserBathroomsError("");
    setUserAddressError("");
    setUserFromTimeError("");
    setUserUntillTimeError("");
    setUserDateError("");
    setUserUnitError("");

    if (userAddress.trim() === "" && userAddress.length === 0) {
      setUserAddressError("Full Address is Required.");
      isValid = false;
    } else if (userAddress.length > 255) {
      setUserAddressError("Full Address cannot exceed 255 characters.");
      isValid = false;
    }
    if (userResidence === "") {
      setUserResidenceError("Please select the type of residence.");
      isValid = false;
    }
    if (userServiceId === "") {
      setUserServiceIdError("Please select the service.");
      isValid = false;
    }
    if (userCity === "") {
      setUserCityError("Please select the city.");
      isValid = false;
    }
    if (userBedrooms === "") {
      setUserBedroomsError("Please select the total number of bedrooms.");
      isValid = false;
    }
    if (userBathrooms === "") {
      setUserBathroomsError("Please select the total number of bathrooms.");
      isValid = false;
    }

    if (userFromTime === "") {
      setUserFromTimeError("Please Select a From time.");
      isValid = false;
    }

    if (userUntillTime === "") {
      setUserUntillTimeError("Please Select an Until time.");
      isValid = false;
    } else if (untillTime24 <= fromTime24) {
      setUserUntillTimeError("Until time must be greater than From time.");
      isValid = false;
    }
    if (userDate.trim() === "" && userDate.length === 0) {
      setUserDateError("Please select the date.");
      isValid = false;
    }

    return isValid;
  }, [
    userResidence,
    userServiceId,
    userBedrooms,
    userBathrooms,
    userCity,
    userAddress,
    userFromTime,
    userUntillTime,
    userDate,
  ]);

  const handleCheckAvailabilityForm = React.useCallback(
    (e) => {
      e.preventDefault();
      setBookSecondFormShow(false);

      const isValidForm = ValidateCheckAvailabilityForm();
      if (isValidForm) {
        dispatch(
          getCleaningSameDayList({
            data: {
              vResidence: userResidence,
              iServiceId: userServiceId,
              iCityId: userCity,
              vBedrooms: userBedrooms,
              vBathrooms: userBathrooms,
              vExtras: userSelectedExtras.length > 0 ? userSelectedExtras : [],
              vUnit: userUnit,
              vAddress: userAddress,
              vFrom: userFromTime,
              vUntill: userUntillTime,
              vDate: userDate,
            },
            pathname: location.pathname,
          })
        );
      }
    },
    [
      ValidateCheckAvailabilityForm,
      dispatch,
      userResidence,
      userServiceId,
      userBedrooms,
      userBathrooms,
      userSelectedExtras,
      userCity,
      userAddress,
      userFromTime,
      userUntillTime,
      userDate,
      userUnit,
      location.pathname,
    ]
  );

  React.useEffect(() => {
    if (cleaningSameDayData && cleaningSameDayData.code === 200) {
      setIsBookLoading(true);

      sessionStorage.setItem(
        "bookScheduledTime",
        cleaningSameDayData?.scheduled_time
      );

      sessionStorage.setItem("bookTax", cleaningSameDayData?.tax);

      sessionStorage.setItem("bookPrice", cleaningSameDayData?.total_price);
      sessionStorage.setItem(
        "bookEstimatedTime",
        cleaningSameDayData?.estimated_time
      );
      sessionStorage.setItem(
        "bookPricePerHour",
        cleaningSameDayData?.price_per_hour
      );
      sessionStorage.setItem(
        "bookFinalPrice",
        cleaningSameDayData?.final_price
      );

      setTimeout(() => {
        setUserResidence("");
        setUserBedrooms("");
        setUserServiceId("");
        setUserCity("");
        setUserBathrooms("");
        setUserSelectedExtras("");
        setUserAddress("");
        setUserFromTime("");
        setUserUntillTime("");
        setUserDate("");
        setUserUnit("");

        sessionStorage.setItem("bookCheckAvailabilityClick", true);
        setIsBookLoading(false);
      }, 2000);
      dispatch(ResetCleaningSameDayDataState());
    } else if (cleaningSameDayData && cleaningSameDayData.code === 404) {
      sessionStorage.setItem("bookCheckAvailabilityClick", false);
      setBookSecondFormShow(true);
      setFormTwoMessageError(cleaningSameDayData.message);
    } else if (cleaningSameDayData && cleaningSameDayData.code === 400) {
      sessionStorage.setItem("bookCheckAvailabilityClick", false);
      setBookSecondFormShow(true);
      setFormTwoMessageError(cleaningSameDayData.message);
    }
  }, [dispatch, cleaningSameDayData]);

  const handleModifyClick = () => {
    setBookSecondFormShow(true);
    updateStateFromSessionStorage();
    sessionStorage.removeItem("bookCheckAvailabilityClick");
  };

  const handleBackClick = () => {
    setBookLoading(false);
    setBookFirstFormShow(true);
    setTimeout(() => {
      sessionStorage.removeItem("bookSubmitClick");
      sessionStorage.removeItem("bookSameDayBookingId");
    }, 100);
  };

  const handleBookNowClick = React.useCallback((event) => {
    event.preventDefault();
    setBookedNowDetailLoading(true);

    const timeoutId = setTimeout(() => {
      sessionStorage.setItem("bookedNowButtonClick", true);
      setBookedNowDetailLoading(false);
    }, 2000);

    // Cleanup to avoid memory leaks
    return () => clearTimeout(timeoutId);
  }, []);

  React.useEffect(() => {
    if (bookNowDetailData && bookNowDetailData.code === 200) {
      setTimeout(() => {
        sessionStorage.setItem("bookedNowButtonClick", true);
        setBookedNowDetailLoading(false);
      }, 2000);
      dispatch(ResetBookNowDetailState());
    } else if (bookNowDetailData && bookNowDetailData.code === 404) {
      setFormErrorMessage(bookNowDetailData.message);
    } else if (bookNowDetailData && bookNowDetailData.code === 400) {
      setFormErrorMessage(bookNowDetailData.message);
    }
  }, [dispatch, bookNowDetailData]);

  const closeIt = () => {
    setBookFirstFormShow(true);
    sessionStorage.removeItem("bookSameDayBookingId");
    sessionStorage.removeItem("bookCheckAvailabilityClick");
    sessionStorage.removeItem("bookSubmitClick");
    sessionStorage.removeItem("bookPayButtonClick");
    sessionStorage.removeItem("bookedNowButtonClick");
    sessionStorage.removeItem("bookScheduledTime");
    sessionStorage.removeItem("bookPrice");
    sessionStorage.removeItem("bookEstimatedTime");
    sessionStorage.removeItem("bookPricePerHour");
    sessionStorage.removeItem("bookTax");
    sessionStorage.removeItem("bookFinalPrice");
    sessionStorage.removeItem("bookCustomerName");
    sessionStorage.removeItem("bookCity");
    sessionStorage.removeItem("bookSelectedServiceName");

    sessionStorage.removeItem("bookSelectedExtras");
    sessionStorage.removeItem("bookCustomerEmail");
    sessionStorage.removeItem("bookBathroom");
    sessionStorage.removeItem("bookFromTime");
    sessionStorage.removeItem("bookCustomerPhone");
    sessionStorage.removeItem("bookDate");
    sessionStorage.removeItem("bookResidence");
    sessionStorage.removeItem("bookServiceId");
    sessionStorage.removeItem("bookUntillTime");
    sessionStorage.removeItem("bookAddress");
    sessionStorage.removeItem("bookBedroom");
    sessionStorage.removeItem("bookUnit");
    sessionStorage.removeItem("discountedBookNowTotalAmount");
  };

  window.onbeforeunload = closeIt;

  const convertTo24Hour = (time) => {
    let [hour, minute] = time.split(":");
    let modifier = time.includes("AM") ? "AM" : "PM";

    hour = parseInt(hour, 10);
    minute = parseInt(minute || "00", 10); // Handle cases without minutes

    if (modifier === "PM" && hour !== 12) {
      hour += 12;
    }
    if (modifier === "AM" && hour === 12) {
      hour = 0;
    }

    return hour * 60 + minute; // Convert time to total minutes for accurate comparison
  };

  React.useEffect(() => {
    const handlePlaceSelect = () => {
      const addressObject = autocomplete.current.getPlace();
      if (addressObject && addressObject.formatted_address) {
        const selectedAddress = addressObject.formatted_address;
        setUserAddress(selectedAddress);
        sessionStorage.setItem("bookAddress", selectedAddress);
        setUserAddressError("");
      }
    };

    const handleScriptLoad = () => {
      if (
        window.google &&
        window.google.maps &&
        window.google.maps.places &&
        autocompleteRef.current
      ) {
        autocomplete.current = new window.google.maps.places.Autocomplete(
          autocompleteRef.current,
          {
            componentRestrictions: { country: "ca" }, // Restrict to Canada
          }
        );

        autocomplete.current.addListener("place_changed", handlePlaceSelect);
      }
    };

    if (!window.google || !window.google.maps || !window.google.maps.places) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=AIzaSyA5T2q_2XgLCc3vz-xzxekc2q5vO3NXvbQ&libraries=places`,
        handleScriptLoad
      );
    } else {
      handleScriptLoad();
    }

    if (userCity !== "" && autocompleteRef.current) {
      handleScriptLoad();
    }
  }, [userCity]);

  // let headings = {};

  // if (labelDetailData?.code === 200) {
  //   const labelMap = Object.fromEntries(
  //     labelDetailData.data.map(({ vLabel, tText }) => [vLabel, tText])
  //   );

  //   headings = {
  //     singleVisit: labelMap["LBL_BOOK_NOW_SINGLE_VISITE_SERVICE_HEADING"] || "",
  //     bookCleaner:
  //       labelMap["LBL_BOOK_NOW_SINGLE_VISITE_SERVICE_SUB_HEADING"] || "",
  //     sameDayCleaner:
  //       labelMap["LBL_BOOK_NOW_FIND_A_SAME_DAY_CLEANER_NOW_HEADING"] || "",
  //     privacy:
  //       labelMap["LBL_BOOK_NOW_WE_RESPECT_YOUR_PRIVACY_SUB_HEADING"] || "",
  //   };
  // }

  const labelMap = React.useMemo(() => {
    if (labelDetailData?.code === 200 && Array.isArray(labelDetailData.data)) {
      return new Map(
        labelDetailData.data.map((item) => [item.vLabel, item.tText])
      );
    }
    return new Map();
  }, [labelDetailData]);

  const singleVisitHeading =
    labelMap.get("LBL_BOOK_NOW_SINGLE_VISITE_SERVICE_HEADING") || "";
  const bookCleanerHeading =
    labelMap.get("LBL_BOOK_NOW_SINGLE_VISITE_SERVICE_SUB_HEADING") || "";
  const sameDayCleanerHeading =
    labelMap.get("LBL_BOOK_NOW_FIND_A_SAME_DAY_CLEANER_NOW_HEADING") || "";
  const privacyHeading =
    labelMap.get("LBL_BOOK_NOW_WE_RESPECT_YOUR_PRIVACY_SUB_HEADING") || "";

  const fullNameText = labelMap.get("LBL_BOOK_NOW_FULL_NAME_TEXT") || "";
  const emailAddressText =
    labelMap.get("LBL_BOOK_NOW_EMAIL_ADDRESS_TEXT") || "";
  const phoneNumberText = labelMap.get("LBL_BOOK_NOW_PHONE_NUMBER_TEXT") || "";

  const almostThereHeading =
    labelMap.get("LBL_BOOK_NOW_ALMOST_THERE_HEADING") || "";
  const recidenceText =
    labelMap.get("LBL_BOOK_NOW_TYPE_OF_RESIDENCE_TEXT") || "";
  const totalBedroomsText =
    labelMap.get("LBL_BOOK_NOW_TOTAL_BEDROOMS_TEXT") || "";

  const totalBathroomsText =
    labelMap.get("LBL_BOOK_NOW_TOTAL_BATHROOMS_TEXT") || "";
  const serviceText = labelMap.get("LBL_BOOK_NOW_SERVICE_TEXT") || "";
  const extrasText = labelMap.get("LBL_BOOK_NOW_EXTRAS_TEXT") || "";

  const aptUnitText = labelMap.get("LBL_BOOK_NOW_APT_UNIT_TEXT") || "";
  const fullAddressText = labelMap.get("LBL_BOOK_NOW_FULL_ADDRESS_TEXT") || "";

  const cityText = labelMap.get("LBL_BOOK_NOW_CITY_TEXT") || "";
  const DateText = labelMap.get("LBL_BOOK_NOW_DATE_TEXT") || "";
  const timeRangeText =
    labelMap.get("LBL_BOOK_NOW_SELECT_TIME_RANGE_TEXT") || "";

  const fromText = labelMap.get("LBL_BOOK_NOW_FROM_TEXT") || "";
  const untilText = labelMap.get("LBL_BOOK_NOW_UNTIL_TIME_TEXT") || "";
  const longerTimeframeText =
    labelMap.get("LBL_BOOK_NOW_THE_LONGER_TIMEFRAME_NOTE") || "";

  const successText = labelMap.get("LBL_BOOK_NOW_SUCCESS_HEADING") || "";

  const successOneDesc =
    labelMap.get("LBL_BOOK_NOW_SUCCESS_FIRST_DESCRIPTION") || "";
  const successTwoDesc =
    labelMap.get("LBL_BOOK_NOW_SUCCESS_SECOND_DESCRIPTION") || "";
  const cleaningbookedText =
    labelMap.get("LBL_BOOK_NOW_CLEANING_BOOKED_TEXT") || "";
  const addonsText = labelMap.get("LBL_BOOK_NOW_ADD_ONS_TEXT") || "";

  const totalPriceText = labelMap.get("LBL_BOOK_NOW_TOTAL_PRICE_TEXT") || "";

  return (
    <>
      <section
        className="howitwork-section book-howitwork-section pt-100"
        id="bookingavailability"
      >
        <div className="container">
          <div className="row pb-50">
            <div className="col-lg-12 text-center">
              <span className="small-title">{singleVisitHeading}</span>
              <h1 className="main-title mb-0">{bookCleanerHeading}</h1>
            </div>
          </div>
        </div>
      </section>
      {bookSubmitClick && bookFirstFormShow === false ? (
        <>
          {isBookLoading ? (
            <section className="position-relative pb-100">
              <div className="container">
                <div className="row">
                  <div className="col-lg-7 col-md-10 mx-auto">
                    <div className="contactcard">
                      <Preloader />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <>
              {bookCheckAvailabilityClick &&
              !isBookLoading &&
              bookSecondFormShow === false ? (
                <>
                  {bookedNowButtonClick && !bookedNowDetailLoading ? (
                    <>
                      <section className="homecontact-section pb-100">
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-7 col-md-10 mx-auto">
                              <div className="contactcard">
                                <PaymentForm
                                  bookFirstFormShow={false}
                                  setBookFirstFormShow={setBookFirstFormShow}
                                  setUserFullName={setUserFullName}
                                  setUserEmail={setUserEmail}
                                  setUserPhone={setUserPhone}
                                  labelDetailData={labelDetailData}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </>
                  ) : (
                    <section className="homecontact-section pb-100">
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-7 col-md-10 mx-auto">
                            <div className="contactcard">
                              <div className="getintouch-content text-center ps-0 pt-0">
                                <h2 className="main-title">{successText}</h2>
                                <p className="contactgray-para">
                                  {successOneDesc}{" "}
                                  <span>
                                    {bookFromTimeNewValue} and{" "}
                                    {bookUntillTimeNewValue}
                                  </span>
                                  {successTwoDesc}
                                </p>
                                <div className="book-time-sort">
                                  <ul>
                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          Your Cleaning can start between{" "}
                                          <span>
                                            {bookFromTimeNewValue} and{" "}
                                            {bookUntillTimeNewValue}
                                          </span>{" "}
                                          on {finalBookDatebookValue}, at{" "}
                                          {bookUserAddressValue}.
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          {cleaningbookedText}{" "}
                                          <span>{bookSelectedServiceName}</span>
                                        </div>
                                      </div>
                                    </li>

                                    {bookExtrasfinalValue.length > 0 ? (
                                      <li>
                                        <div className="d-flex align-items-md-center">
                                          <div className="icon-list">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                            >
                                              <path
                                                d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                                fill="#FF6F00"
                                              />
                                              <path
                                                d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                                fill="#FF6F00"
                                              />
                                            </svg>
                                          </div>
                                          <div className="sort-list-desc">
                                            {addonsText}{" "}
                                            <span>{bookExtrasfinalValue}</span>
                                          </div>
                                        </div>
                                      </li>
                                    ) : (
                                      ""
                                    )}
                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          Estimated Hours:{" "}
                                          <span>{bookEstimatedTime}</span>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          Price Per Hour:{" "}
                                          <span>${bookPricePerHour}</span>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          {totalPriceText}{" "}
                                          <span>${bookCleningPrice}</span>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                {formErrorMessage && (
                                  <div className="validation-error">
                                    {formErrorMessage}
                                  </div>
                                )}
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    justifyContent: "center",
                                  }}
                                >
                                  {bookedNowDetailLoading ? (
                                    <>
                                      {" "}
                                      <button
                                        className="success-orangebtn"
                                        type="button"
                                        disabled
                                      >
                                        <span
                                          className="spinner-border spinner-border-sm me-1 custom-spinner"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        Loading...
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        type="submit"
                                        className="success-orangebtn"
                                        onClick={handleBookNowClick}
                                      >
                                        Book Now
                                      </button>
                                    </>
                                  )}
                                  <button
                                    type="button"
                                    className="success-orangebtn success-bluebtn"
                                    onClick={handleModifyClick}
                                  >
                                    Modify
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  )}
                </>
              ) : (
                <>
                  <section className="homecontact-section pb-100">
                    <div className="container">
                      <div className="row justify-content-center">
                        <div className="col-lg-10">
                          <div className="contactcard">
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="getintouch-content p-0">
                                  <h2 className="main-title">
                                    {bookCustomerName} {almostThereHeading}
                                  </h2>
                                  <form className="login-form p-0">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {recidenceText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={userResidence}
                                            onChange={handleResidence}
                                          >
                                            <option value="">
                                              Select Type of Residence
                                            </option>
                                            {residenceTypeData &&
                                              residenceTypeData.code === 200 &&
                                              residenceTypeData.data &&
                                              residenceTypeData.data.map(
                                                (type, typeIndex) => (
                                                  <option
                                                    key={typeIndex}
                                                    value={type.vResidenceType}
                                                  >
                                                    {type.vResidenceType}
                                                  </option>
                                                )
                                              )}
                                          </select>
                                          {userResidencError && (
                                            <div className="validation-error">
                                              {userResidencError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {totalBedroomsText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={userBedrooms}
                                            onChange={handleBedrooms}
                                          >
                                            {" "}
                                            <option value="">
                                              Select Total Bedrooms{" "}
                                            </option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                          </select>
                                          {userBedroomsError && (
                                            <div className="validation-error">
                                              {userBedroomsError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {totalBathroomsText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={userBathrooms}
                                            onChange={handleBathrooms}
                                          >
                                            <option value="">
                                              Select Total Bathrooms
                                            </option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                          </select>
                                          {userBathroomsError && (
                                            <div className="validation-error">
                                              {userBathroomsError}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {serviceText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={userServiceId}
                                            onChange={handleServiceChange}
                                          >
                                            <option value="">
                                              Select Service
                                            </option>
                                            {servicesDetailData &&
                                            servicesDetailData.code === 200 &&
                                            servicesDetailData.data ? (
                                              servicesDetailData.data.map(
                                                (service, serviceIndex) => (
                                                  <option
                                                    value={service.iServiceId}
                                                    key={serviceIndex}
                                                  >
                                                    {service.vServiceName}
                                                  </option>
                                                )
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </select>
                                          {userServiceIdError && (
                                            <div className="validation-error">
                                              {userServiceIdError}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div className="col-lg-12">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputEmail1"
                                            className="form-label"
                                          >
                                            {extrasText}
                                          </label>
                                          <div className="contact-checkedDiv">
                                            {extrasDetailData &&
                                              extrasDetailData.code === 200 &&
                                              Array.isArray(
                                                extrasDetailData.data
                                              ) &&
                                              extrasDetailData.data.map(
                                                (extra, index) => (
                                                  <div
                                                    key={index}
                                                    className="form-check form-check-inline"
                                                  >
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={`inlineCheckbox${index}`}
                                                      value={extra.vExtras}
                                                      onChange={
                                                        handleCheckboxChange
                                                      }
                                                      checked={userSelectedExtras.includes(
                                                        extra.vExtras
                                                      )}
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      htmlFor={`inlineCheckbox${index}`}
                                                    >
                                                      <img
                                                        width="17"
                                                        height="22"
                                                        src={extra.vImage}
                                                        alt={extra.vExtras}
                                                        loading="lazy"
                                                      />{" "}
                                                      <span
                                                        style={{
                                                          marginLeft: "8px",
                                                        }}
                                                      >
                                                        {extra.vExtras}
                                                      </span>
                                                    </label>
                                                  </div>
                                                )
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {cityText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={userCity}
                                            onChange={handleCity}
                                          >
                                            <option value="">
                                              Select City
                                            </option>

                                            {cityListingData &&
                                            cityListingData.code === 200 &&
                                            cityListingData.data ? (
                                              cityListingData.data
                                                .slice()
                                                .sort((a, b) =>
                                                  a.vCity.localeCompare(b.vCity)
                                                )
                                                .map((city, index) => (
                                                  <option
                                                    value={city.iCityId}
                                                    key={index}
                                                  >
                                                    {city.vCity}
                                                  </option>
                                                ))
                                            ) : (
                                              <></>
                                            )}
                                          </select>
                                          {userCityError && (
                                            <div className="validation-error">
                                              {userCityError}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      {userCity.length > 0 ? (
                                        <>
                                          <div className="col-lg-6">
                                            <div className="login-inputDiv">
                                              <label
                                                htmlFor="exampleInputname"
                                                className="form-label"
                                              >
                                                {aptUnitText}
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                id="exampleInputphone"
                                                placeholder="Enter Apt/Unit"
                                                value={userUnit}
                                                onChange={handleUnitChange}
                                              />
                                              {userUnitError && (
                                                <div className="validation-error">
                                                  {userUnitError}
                                                </div>
                                              )}
                                            </div>
                                          </div>

                                          <div className="col-lg-6">
                                            <div className="login-inputDiv">
                                              <label
                                                htmlFor="exampleInputname"
                                                className="form-label"
                                              >
                                                {fullAddressText}
                                              </label>
                                              <input
                                                ref={autocompleteRef}
                                                type="text"
                                                className="form-control"
                                                placeholder={
                                                  "Search Full Address..."
                                                }
                                                value={userAddress}
                                                onChange={(event) => {
                                                  setUserAddress(
                                                    event.target.value
                                                  );
                                                  sessionStorage.setItem(
                                                    "bookAddress",
                                                    event.target.value
                                                  );
                                                }}
                                              />
                                              {userAddressError && (
                                                <div className="validation-error">
                                                  {userAddressError}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </>
                                      ) : null}
                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="Date"
                                            className="form-label"
                                          >
                                            {DateText}
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            value={userDate}
                                            onClick={handleDateDivClick}
                                            onChange={handleDateChange}
                                            min={
                                              new Date()
                                                .toISOString()
                                                .split("T")[0]
                                            }
                                            ref={dateInputRef}
                                          />
                                          {userDateError && (
                                            <div className="validation-error">
                                              {userDateError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-12">
                                        <p className="form-importantpara">
                                          {timeRangeText}
                                        </p>
                                      </div>

                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {fromText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={userFromTime}
                                            onChange={handleFromTime}
                                          >
                                            <option value="">From</option>
                                            {userAvailableTimes?.map(
                                              (time, index) => (
                                                <option
                                                  key={index}
                                                  value={time}
                                                >
                                                  {time}
                                                </option>
                                              )
                                            )}
                                          </select>
                                          {userFromTimeError && (
                                            <div className="validation-error">
                                              {userFromTimeError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {untilText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={userUntillTime}
                                            onChange={handleUntillTime}
                                          >
                                            <option value="">Until</option>

                                            {userAvailableTimes
                                              .filter((item) => {
                                                const itemTime =
                                                  convertTo24Hour(item);
                                                const fromTime24 =
                                                  convertTo24Hour(userFromTime);
                                                return (
                                                  itemTime > fromTime24 &&
                                                  itemTime <= 23 * 60
                                                ); // Convert 11 PM to minutes
                                              })
                                              .map((untime, unindex) => (
                                                <option
                                                  key={unindex}
                                                  value={untime}
                                                >
                                                  {untime}
                                                </option>
                                              ))}
                                          </select>
                                          {userUntillTimeError && (
                                            <div className="validation-error">
                                              {userUntillTimeError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-12">
                                        <p className="contactgray-para">
                                          {longerTimeframeText}
                                        </p>
                                      </div>
                                      {formTwoMessageError && (
                                        <div className="validation-error">
                                          {formTwoMessageError}
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <button
                                        type="submit"
                                        className="success-orangebtn"
                                        onClick={handleCheckAvailabilityForm}
                                      >
                                        Check Availability
                                      </button>
                                      <button
                                        type="button"
                                        className="success-orangebtn success-bluebtn"
                                        onClick={handleBackClick}
                                      >
                                        Back
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <section className="homecontact-section pb-100">
          <div className="container">
            <div className="contactcard ">
              <div className="row">
                <div className="col-lg-6">
                  <img
                    className="contact-cardimg"
                    // width="4096"
                    // height="2731"
                    width="600"
                    height="540"
                    // src="/assets/images/contact-1.png"
                    // src="/assets/images/contact-1.webp"
                    src="/assets/images/contact-1-new.webp"
                    alt="Login"
                    // loading="lazy"
                  />
                </div>
                <div className="col-lg-6">
                  <div className="getintouch-content">
                    <h2 className="main-title">{sameDayCleanerHeading}</h2>
                    <form
                      className="login-form p-0"
                      onSubmit={handleSameDayBookFormNew}
                    >
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="login-inputDiv">
                            <label
                              htmlFor="exampleInputname"
                              className="form-label"
                            >
                              {fullNameText}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputname"
                              placeholder="Enter Full Name"
                              value={userfullName}
                              onChange={(event) => {
                                const value = event.target.value;
                                if (/^[a-zA-Z\s]*$/.test(value)) {
                                  handleFullNameChange(event);
                                }
                              }}
                              maxLength="50"
                            />
                            {userFullNameError && (
                              <div className="validation-error">
                                {userFullNameError}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="login-inputDiv">
                            <label
                              htmlFor="exampleInputEmail1"
                              className="form-label"
                            >
                              {emailAddressText}
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="exampleInputEmail1"
                              placeholder="Enter Email Address"
                              value={userEmail}
                              onChange={handleEmailChange}
                            />
                            {userEmailError && (
                              <div className="validation-error">
                                {userEmailError}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="login-inputDiv">
                            <label
                              htmlFor="exampleInputname"
                              className="form-label"
                            >
                              {phoneNumberText}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputphone"
                              placeholder="Enter Phone Number"
                              value={userPhone}
                              onChange={handlePhoneChange}
                              maxLength="10"
                            />
                            {userPhoneError && (
                              <div className="validation-error">
                                {userPhoneError}
                              </div>
                            )}
                          </div>
                        </div>

                        {formOneMessageError && (
                          <div className="validation-error">
                            {formOneMessageError}
                          </div>
                        )}
                      </div>
                      {bookLoading ? (
                        <>
                          {" "}
                          <button
                            className="success-orangebtn"
                            type="button"
                            disabled
                          >
                            <span
                              className="spinner-border spinner-border-sm me-1 custom-spinner"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Loading...
                          </button>
                        </>
                      ) : (
                        <button type="submit" className="success-orangebtn">
                          Continue
                        </button>
                      )}
                      <p className="contactgray-para mt-3">{privacyHeading}</p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export { BookFormOne, useBookNowClearSessionOnNavigation };
